import React from 'react';
const ClubStickyFooterLg = ({ ...r }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 1367 97" {...r}>
            <path d="M0 1h1366v96H0z"></path>
            <path
                fill="#fff"
                d="M1 43a1 1 0 100-2 1 1 0 000 2zm0 6a1 1 0 100-2 1 1 0 000 2zm6 0a1 1 0 100-2 1 1 0 000 2zm-6 6a1 1 0 100-2 1 1 0 000 2zm6 0a1 1 0 100-2 1 1 0 000 2zm6 0a1 1 0 100-2 1 1 0 000 2zM1 61a1 1 0 100-2 1 1 0 000 2zm0 6a1 1 0 100-2 1 1 0 000 2zm6-6a1 1 0 100-2 1 1 0 000 2zm0 6a1 1 0 100-2 1 1 0 000 2zm6-6a1 1 0 100-2 1 1 0 000 2zm0 6a1 1 0 100-2 1 1 0 000 2zm6-6a1 1 0 100-2 1 1 0 000 2zm0 6a1 1 0 100-2 1 1 0 000 2zm6 0a1 1 0 100-2 1 1 0 000 2zM1 73a1 1 0 100-2 1 1 0 000 2zm6 0a1 1 0 100-2 1 1 0 000 2zm6 0a1 1 0 100-2 1 1 0 000 2zm6 0a1 1 0 100-2 1 1 0 000 2zm6 0a1 1 0 100-2 1 1 0 000 2zm6 0a1 1 0 100-2 1 1 0 000 2z"
                opacity="0.5"
            ></path>
            <g
                stroke="#fff"
                strokeLinecap="square"
                strokeWidth="0.5"
                clipPath="url(#banner-a)"
            >
                <path d="M88 25l16 8m-16 0l16 8m-16 0l16 8m-16 0l16 8m-16 0l16 8"></path>
            </g>
            <path
                fill="url(#banner-b)"
                fillOpacity="0.7"
                fillRule="evenodd"
                d="M215.52 1h107.52L215.52 97H108L215.52 1z"
                clipRule="evenodd"
            ></path>
            <path
                fill="url(#banner-c)"
                fillOpacity="0.8"
                fillRule="evenodd"
                d="M263.52 1h69.12L231.67 91.152A23.02 23.02 0 01216.34 97c-21.14 0-31.1-26.108-15.33-40.187L263.52 1z"
                clipRule="evenodd"
            ></path>
            <path
                fill="url(#banner-d)"
                fillOpacity="0.8"
                fillRule="evenodd"
                d="M316.49 6.848A23.02 23.02 0 01331.82 1c21.14 0 31.1 26.108 15.33 40.187l-55.96 49.965A23.02 23.02 0 01275.86 97c-21.14 0-31.099-26.108-15.33-40.187l55.96-49.965z"
                clipRule="evenodd"
            ></path>
            <path
                stroke="#fff"
                strokeWidth="0.5"
                d="M1118 73c6.63 0 12-5.373 12-12s-5.37-12-12-12-12 5.373-12 12 5.37 12 12 12z"
                opacity="0.5"
            ></path>
            <circle cx="1172" cy="37" r="1" fill="#fff"></circle>
            <circle cx="1187" cy="37" r="1" fill="#fff"></circle>
            <circle cx="1182" cy="27" r="1" fill="#fff"></circle>
            <circle cx="1182" cy="32" r="1" fill="#fff"></circle>
            <circle cx="1177" cy="37" r="1" fill="#fff"></circle>
            <circle cx="1192" cy="37" r="1" fill="#fff"></circle>
            <circle cx="1182" cy="37" r="1" fill="#fff"></circle>
            <circle cx="1182" cy="42" r="1" fill="#fff"></circle>
            <circle
                cx="1178.46"
                cy="33.464"
                r="1"
                fill="#fff"
                transform="rotate(-45 1178.46 33.464)"
            ></circle>
            <circle
                cx="1185.54"
                cy="40.536"
                r="1"
                fill="#fff"
                transform="rotate(-45 1185.54 40.536)"
            ></circle>
            <circle
                cx="1185.54"
                cy="33.465"
                r="1"
                fill="#fff"
                transform="rotate(45 1185.54 33.465)"
            ></circle>
            <circle
                cx="1178.46"
                cy="40.535"
                r="1"
                fill="#fff"
                transform="rotate(45 1178.46 40.535)"
            ></circle>
            <circle cx="1182" cy="47" r="1" fill="#fff"></circle>
            <path
                stroke="#fff"
                strokeWidth="0.5"
                d="M1281.79 1H1350l-71.57 65.558c-9.68 8.865-24.63 8.542-33.92-.733-8.68-8.673-8.68-22.736 0-31.41.29-.286.58-.564.89-.834L1281.79 1z"
                clipRule="evenodd"
                opacity="0.5"
            ></path>
            <path
                stroke="#fff"
                strokeWidth="0.5"
                d="M1310.49 1H1366v11.732l-47.87 45.627c-9.55 9.1-24.39 8.814-33.6-.646-8.71-8.937-8.71-23.427 0-32.364.24-.249.49-.492.74-.729L1310.49 1z"
                clipRule="evenodd"
                opacity="0.5"
            ></path>
            <defs>
                <linearGradient
                    id="banner-b"
                    x1="1091.96"
                    x2="-49.589"
                    y1="42.456"
                    y2="85.223"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#fff" stopOpacity="0.5"></stop>
                    <stop offset="1" stopColor="#fff" stopOpacity="0"></stop>
                </linearGradient>
                <linearGradient
                    id="banner-c"
                    x1="643.05"
                    x2="125.151"
                    y1="40.22"
                    y2="78.83"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#fff" stopOpacity="0.5"></stop>
                    <stop offset="1" stopColor="#fff" stopOpacity="0"></stop>
                </linearGradient>
                <linearGradient
                    id="banner-d"
                    x1="702.57"
                    x2="189.745"
                    y1="32.446"
                    y2="104.529"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#fff" stopOpacity="0.5"></stop>
                    <stop offset="1" stopColor="#fff" stopOpacity="0"></stop>
                </linearGradient>
                <clipPath id="banner-a">
                    <path
                        fill="#fff"
                        d="M0 0h16v40H0z"
                        transform="translate(88 25)"
                    ></path>
                </clipPath>
            </defs>
        </svg>
    );
}

export default ClubStickyFooterLg;